import type { ComponentProps } from "react";
import ShikiHighlighter from "react-shiki/web";
import { SHIKI_THEMES } from "@/lib/shiki-themes";
import { cn } from "@/lib/utils";

function CodeBlock({ children, className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "not-prose flex w-full flex-col overflow-clip border",
        "rounded-xl border-border bg-card text-card-foreground",
        className
      )}
      data-slot="code-block"
      {...props}
    >
      {children}
    </div>
  );
}

type CodeBlockCodeProps = {
  code: string;
  language?: string;
} & ComponentProps<"div">;

function CodeBlockCode({
  code,
  language = "tsx",
  className,
  ...props
}: CodeBlockCodeProps) {
  return (
    <div
      className={cn(
        "w-full overflow-x-auto text-[13px] [&_.shiki]:px-4 [&_.shiki]:py-4",
        className
      )}
      data-slot="code-block-code"
      {...props}
    >
      {code ? (
        <ShikiHighlighter
          addDefaultStyles={false}
          defaultColor={false}
          language={language}
          showLanguage={false}
          theme={SHIKI_THEMES}
        >
          {code}
        </ShikiHighlighter>
      ) : (
        <pre>
          <code />
        </pre>
      )}
    </div>
  );
}

function CodeBlockGroup({
  children,
  className,
  ...props
}: ComponentProps<"div">) {
  return (
    <div
      className={cn("flex items-center justify-between", className)}
      data-slot="code-block-group"
      {...props}
    >
      {children}
    </div>
  );
}

export type { CodeBlockCodeProps };
export { CodeBlock, CodeBlockCode, CodeBlockGroup };
